import { render, staticRenderFns } from "./canceledModal.vue?vue&type=template&id=1373ae2c&"
import script from "./canceledModal.vue?vue&type=script&lang=js&"
export * from "./canceledModal.vue?vue&type=script&lang=js&"
import style0 from "./canceledModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports